export default "__VITE_ASSET__BvWbrz3J__"